import React, { useState, useEffect } from "react";
import { Modal, Button, Radio } from "antd";
import { BellOutlined } from "@ant-design/icons";

const ReminderModal = ({ show, handleClose, onSave, initialMinutes, onCancel }) => {
  // Reminder options in minutes
  const reminders = [
    { label: "5 minutes before", value: 5 },
    { label: "30 minutes before", value: 30 },
    { label: "1 hour before", value: 60 },
    { label: "1 day before", value: 1440 },
  ];

  const [selectedValue, setSelectedValue] = useState(null);

  useEffect(() => {
    if (initialMinutes != null) {
      setSelectedValue(initialMinutes);
    }
  }, [initialMinutes]);

  const handleSave = () => {
    onSave(selectedValue); // send minutes back to parent
    handleClose();
  };

  return (
    <Modal
      title={
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <BellOutlined /> Reminder
        </div>
      }
      open={show}
      onCancel={onCancel}
      footer={null}
      centered
      width={400}
    >
      <Radio.Group
        value={selectedValue}
        onChange={(e) => setSelectedValue(e.target.value)}
        style={{ display: "flex", flexDirection: "column", gap: "12px" }}
      >
        {reminders.map((reminder) => (
          <Radio key={reminder.value} value={reminder.value}>
            {reminder.label}
          </Radio>
        ))}
      </Radio.Group>

      <Button
        type="primary"
        block
        style={{
          marginTop: "20px",
          backgroundColor: "#9B51E0",
          height: "45px",
          fontSize: "16px",
          borderRadius: "8px",
        }}
        onClick={handleSave}
        disabled={selectedValue == null}
      >
        Save
      </Button>
    </Modal>
  );
};

export default ReminderModal;
